import { CreditCardPayModel } from '../models/creditCardPay.model';
import { ConfigurationModel } from '../models/configuration.model';
import { DependentModel } from '../models/dependent.model';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { RechargeModel } from '../models/recharge.model';

export class MaskHelper {

  static currencyMask = createNumberMask({
    allowDecimal: true,
    includeThousandsSeparator: true,
    prefix: '',
    suffix: ''
  });

  static removeDependentMask(dependent: DependentModel): DependentModel {
    if (dependent.card) {
      if (dependent.card.balance) {
        dependent.card.balance = MaskHelper.removeCurrency(dependent.card.balance);
      }
    }
    if (dependent.configuration) {
      if (dependent.configuration.dailyLimit) {
        dependent.configuration.dailyLimit = MaskHelper.removeCurrency(dependent.configuration.dailyLimit);
      }
    }
    if (dependent.localBirth) {
      dependent.birth = MaskHelper.removeBirthday(dependent.localBirth);
    }
    return dependent;
  }

  static removeConfigurationMask(configuration: ConfigurationModel): ConfigurationModel {
    if (configuration.dailyLimit) {
      configuration.dailyLimit = MaskHelper._removeCurrency(configuration.dailyLimit);
    }
    if (configuration.recharge.minValue) {
      configuration.recharge.minValue = MaskHelper._removeCurrency(configuration.recharge.minValue);
    }
    if (configuration.recharge.value) {
      configuration.recharge.value = MaskHelper._removeCurrency(configuration.recharge.value);
    }
    return configuration;
  }

  static removeRechargeMask(recharge: RechargeModel): RechargeModel {
    const _r = new RechargeModel();
    if (recharge.amount) {
      _r.amount = MaskHelper._removeCurrency(recharge.amount);
    }
    return _r;
  }

  static removeCreditCardMask(creditCard: CreditCardPayModel): CreditCardPayModel {
    if (creditCard.number) {
      creditCard.number = MaskHelper.removeCreditCard(creditCard.number);
    }
    if (creditCard.expirationDate) {
      const expirationDate = MaskHelper.removeDate(creditCard.expirationDate);
      creditCard.monthExp = parseFloat(expirationDate.month);
      creditCard.yearExp = parseFloat(expirationDate.year);
    }

    return creditCard;
  }

  static removeUserMask(user) {
    if (user.cpf) {
      user.cpf = MaskHelper.removeCpf(user.cpf);
    }
    if (user.telefone) {
      user.telefone = MaskHelper.removeTelefone(user.telefone);
    }

    return user;
  }

  static removeTelefone(telefone) {
    telefone = telefone.replace(' ', '');
    telefone = telefone.replace('-', '');
    return telefone;
  }

  static removeCpf(cpf) {
    let _cpf;
    try {
      _cpf = cpf.replace(/\./g, '').replace('-', '').replace(/\_/g, '');
      return _cpf;
    } catch (err) {
      return false;
    }
  }

  static removeDate(expirationDate: string) {
    const _expirationDate = expirationDate.split('/');
    return {
      month: _expirationDate[0],
      year: _expirationDate[1]
    };
  }

  static removeCreditCard(creditCardNumber: string): string {
    const _creditCardNumber = creditCardNumber;
    return _creditCardNumber.replace(/\ /g, '');
  }

  static removeCurrency(currency): number {
    try {
      return parseFloat(currency.split(' ')[1]);
    } catch (err) {
      return currency;
    }
  }

  static _removeCurrency(currency): number {
    let formatedCurrency = currency;
    try {
      formatedCurrency = formatedCurrency.replace('R$ ', '');
      formatedCurrency = formatedCurrency.replace(/\./g, '');
      formatedCurrency = formatedCurrency.replace(/\,/g, '.');
      return parseFloat(formatedCurrency);
    } catch (err) {
      return currency;
    }
  }

  static removeBirthday(birthday) {
    const year = birthday.split('/')[2];
    const month = birthday.split('/')[1];
    const day = birthday.split('/')[0];
    return new Date(`${month}/${day}/${year}`);
  }

  static moneyToFloat = (text: string) => {
    text = text.replace(/[^0-9]/g, "");
    text = text ? text : '0';
    return Number.parseFloat(text.replace(/[^0-9]/g, "")) / 100;
  }

  static formatDate(date: string): string {
    let result;
    const _date = date.toString().split(/\ /g);
    if (_date[1] === 'Jan') {
      result = `${_date[2]}/Jan`;
    } else if (_date[1] === 'Feb') {
      result = `${_date[2]}/Fev`;
    }  else if (_date[1] === 'Mar') {
      result = `${_date[2]}/Mar`;
    } else if (_date[1] === 'Apr') {
      result = `${_date[2]}/Abr`;
    } else if (_date[1] === 'May') {
      result = `${_date[2]}/Mai`;
    } else if (_date[1] === 'Jun') {
      result = `${_date[2]}/Jun`;
    } else if (_date[1] === 'Jul') {
      result = `${_date[2]}/Jul`;
    } else if (_date[1] === 'Aug') {
      result = `${_date[2]}/Ago`;
    } else if (_date[1] === 'Sep') {
      result = `${_date[2]}/Set`;
    } else if (_date[1] === 'Oct') {
      result = `${_date[2]}/Out`;
    } else if (_date[1] === 'Nov') {
      result = `${_date[2]}/Nov`;
    } else if (_date[1] === 'Dec') {
      result = `${_date[2]}/Dez`;
    } else if (_date[1] === 'Feb') {
      result = `${_date[2]}/Fev`;
    }
    const weekDay = new Date(date.toString()).toLocaleDateString('pt-br', {weekday: 'long'});
    return `${weekDay} ${result} ${_date[4]}`;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/helpers/mask.ts